import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { Observable, forkJoin, tap, map, finalize, catchError, lastValueFrom } from 'rxjs';
import { AuthService } from '../../../../services/auth.service';
import { ClienteService } from '../../../../services/clientes.service';
import { DescricaoPadraoService } from '../../../../services/descricao-padrao.service';
import { NotaFiscalService } from '../../../../services/nota-fiscal-servico.service';
import { ToastService } from '../../../../services/toast.service';
import { JwtHelper } from '../../../../helpers/jwtDecode.helper';
import { FormatadorHelper } from '../../../../helpers/formatador.helper';
import { SeveridadeToast } from '../../../../models/enums/severidade-toast.enum';
import { SpinnerService } from '../../../../services/spinner.service';
import { Location } from '@angular/common';
import { Icones } from '../../../../shared/variaveisDeRotas';
import { NotaFiscalServicoModel } from '../../../../models/notaFiscalServico.model';
import { NFSeStatus } from '../../../../models/enums/nfse-status.enum';
import { retornaDescricao } from '../../../../shared/mock/descricao';


@Component({
  selector: 'app-nfse-emissao',
  providers: [provideNgxMask()],
  templateUrl: './nfse-emissao.component.html',
  styleUrls: ['./nfse-emissao.component.scss'],
})
export class NfseEmissaoComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  readonly codigoNbsOptions = [
    { label: '1.1301.10.00 - Serviços de representação e consultoria jurídica criminal', value: '1.1301.10.00' },
    { label: '1.1301.20.00 - Serviços de representação e consultoria jurídica em outras áreas do direito, exceto consultoria tributária', value: '1.1301.20.00' },
    { label: '1.1301.90.00 - Serviços jurídicos não classificados em subposições anteriores', value: '1.1301.90.00' }
  ];

  readonly indicadorDestinatarioOptions = [
    { label: '0 - Tomador', value: 0 },
  ];

  form = new FormGroup({
    ambiente: new FormControl(''),
    dataEmissao: new FormControl(null),
    isRetroativa: new FormControl(false),
    aceiteDeclaracao: new FormControl(false),
    dataCompetencia: new FormControl(null),
    naturezaOperacao: new FormControl(1),
    prestadorServico: new FormControl({ value: '', disabled: true }),
    optanteSimplesNacional: new FormControl(true),
    incentivadorCultural: new FormControl(null),
    ufId: new FormControl({ value: '', disabled: true }),
    municipioId: new FormControl({ value: '', disabled: true }),
    clienteId: new FormControl('', Validators.required),
    cpfCnpj: new FormControl({ value: '', disabled: true }),
    identificacaoCpfCnpj: new FormControl(1),
    razaoSocial: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    apelido: new FormControl({ value: '', disabled: true }),
    tipoLogradouro: new FormControl({ value: '', disabled: true }),
    logradouro: new FormControl({ value: '', disabled: true }),
    numero: new FormControl({ value: '', disabled: true }),
    complemento: new FormControl({ value: '', disabled: true }),
    inscricaoMunicipal: new FormControl({ value: '', disabled: true }),
    cep: new FormControl({ value: '', disabled: true }),
    estado: new FormControl({ value: '', disabled: true }),
    bairro: new FormControl({ value: '', disabled: true }),
    telefone: new FormControl({ value: '', disabled: true }),
    indicadorDestinatario: new FormControl<number>(0, Validators.required),
    itemListaServico: new FormControl({ value: '17.14 - Advocacia', disabled: true }),
    codigoNbs: new FormControl('', Validators.required),
    descricaoId: new FormControl('', Validators.required),
    discriminacao: new FormControl('', Validators.required),
    usuarioId: new FormControl(''),
    valorServicos: new FormControl('', Validators.required),
    descontoCondicionado: new FormControl(0.0),
    descontoIncondicionado: new FormControl(0.0),
    baseCalculo: new FormControl(0.0),
    aliquota: new FormControl(0.0),
    valorIss: new FormControl(0.0),
  });

  notaFiscalServicoArray: NotaFiscalServicoModel[] = [];
  NFSeStatus = NFSeStatus;
  mostrarNota: boolean = false;
  notaMaisRecente: NotaFiscalServicoModel;
  displayModal = false;
  displayModalDeclaracao = false;
  readonly limiteValorAltoEmissaoNfse = 300_000;
  displayModalConfirmacaoValorAlto = false;
  ufOptions: any[] = [];
  municipioOptions: any[] = [];
  clienteOptions: any[] = [];
  descricaoPadraoOptions: any[] = [];
  dataAtual: Date = new Date();
  private userId: string;
  private codigoMunicipioIbgePrestador: string | null = null;
  private static readonly CodigoMunicipioSaoGoncaloRj = '3304904';
  private static readonly CodigoMunicipioTeresinaPi = '2211001';
  private static readonly CodigoMunicipioRondonopolisMt = '5107602';
  private static readonly CodigoMunicipioMesquitaRj = '3302858';

  constructor(
    private clienteService: ClienteService,
    private descricaoPadraoService: DescricaoPadraoService,
    private authService: AuthService,
    private jwtHelper: JwtHelper,
    private notaFiscalServicoService: NotaFiscalService,
    private toastService: ToastService,
    private router: Router,
    private spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private location: Location
  ) {
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit() {
    this.tituloChange.emit('Emissão de NFS-e');
    this.iconeChange.emit(Icones.arquivoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('emitirNfse').titulo);
    this.textoDescricao.emit(retornaDescricao('emitirNfse').texto);
    this.mostrarDescricao.emit(true)
    this.form.get('itemListaServico').setValue('17.14 - Advocacia')

    this.form.get('isRetroativa')?.valueChanges.subscribe(isRetroativa => {
      const dataCompetenciaControl = this.form.get('dataCompetencia');
      if (isRetroativa) {
        dataCompetenciaControl?.setValidators([Validators.required]);
      } else {
        dataCompetenciaControl?.clearValidators();
        dataCompetenciaControl?.setValue(null);
      }
      dataCompetenciaControl?.updateValueAndValidity();
    });

    this.spinnerService.show('Carregando dados da NFS-e...');
    forkJoin({
      userData: this.loadUserData(),
      clientes: this.loadClientes(),
      descricoesPadrao: this.loadDescricoesPadrao(),
    })
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe({
        next: () => {
          this.checkForReplicatedData();
          this.cdr.detectChanges();
          this.spinnerService.hide();
        },
        error: (error) => {
          this.toastService.setMensagemToast(
            'Erro ao carregar dados iniciais',
            SeveridadeToast.Error
          );
          this.spinnerService.hide();
        }
      });
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  onRetroativaChange(event: any) {
    const isRetroativa = event.checked;
    this.form.patchValue({ isRetroativa });

    if (isRetroativa) {
      this.displayModalDeclaracao = true;
      this.form.patchValue({ aceiteDeclaracao: false });
    } else {
      this.form.patchValue({
        dataCompetencia: null,
        aceiteDeclaracao: false
      });
    }
  }

  aceitarDeclaracao() {
    this.form.patchValue({ aceiteDeclaracao: true });
    this.displayModalDeclaracao = false;
  }

  cancelarDeclaracao() {
    this.form.patchValue({
      isRetroativa: false,
      aceiteDeclaracao: false
    });
    this.displayModalDeclaracao = false;
  }

  onTomadorChange(event: any) {
    const tomadorId = event.value;

    this.clienteService.getClienteById(tomadorId).subscribe((tomador) => {
      this.form.patchValue({ ...tomador });
      if (tomador.uf) {
        this.form.patchValue({
          estado: tomador.uf,
        });
      }
    });
  }

  private loadUserData(): Observable<void> {
    return this.authService.obterUsuarioPorId(this.userId).pipe(
      tap((user) => {
        this.codigoMunicipioIbgePrestador = this.normalizarCodigoIbgeMunicipio(
          user.codigoMunicipio ?? user.codigo_municipio
        );
        this.aplicarValidacaoCodigoNbsPorMunicipio();
        this.form.patchValue({
          prestadorServico: `${user.cpfCnpj} - ${user.nomeEmpresa}`,
          ufId: user.ufId,
          municipioId: user.municipioId,
        });
        this.ufOptions = [{ id: user.ufId, nome: user.uf }];
        this.municipioOptions = [{ id: user.municipioId, nome: user.municipio }];
      }),
      catchError((error) => {
        this.toastService.setMensagemToast(
          'Erro ao carregar dados do usuário',
          SeveridadeToast.Error
        );
        return '';
      }),
      map(() => undefined)
    );
  }

  private loadClientes(): Observable<void> {
    return this.clienteService.getClientes(this.userId).pipe(
      tap((clientes) => {
        this.clienteOptions = clientes.map((cliente) => ({
          label: `${cliente.cpfCnpj} - ${cliente.apelido}`,
          value: cliente.id,
        }));
      }),
      catchError((error) => {
        this.toastService.setMensagemToast(
          'Erro ao carregar lista de clientes',
          SeveridadeToast.Error
        );
        return '';
      }),
      map(() => undefined)
    );
  }

  private loadDescricoesPadrao(): Observable<void> {
    return this.descricaoPadraoService.getDescricaoPadrao(this.userId).pipe(
      tap((descricoes) => {
        this.descricaoPadraoOptions = descricoes.map((desc) => ({
          label: desc.descricao,
          value: desc.id,
          detalhes: desc.detalhes,
        }));
      }),
      catchError((error) => {
        this.toastService.setMensagemToast(
          'Erro ao carregar descrições padrão',
          SeveridadeToast.Error
        );
        return '';
      }),
      map(() => undefined)
    );
  }

  onDescricaoChange(event: any) {
    const descricaoSelecionada = this.descricaoPadraoOptions.find(
      (desc) => desc.value === event.value
    );
    if (descricaoSelecionada) {
      this.form.patchValue({ discriminacao: descricaoSelecionada.detalhes });
    }
  }

  emitirNotaFiscal() {
    if (this.obterValorServicosNumerico() > this.limiteValorAltoEmissaoNfse) {
      this.displayModalConfirmacaoValorAlto = true;
      return;
    }
    this.executarEmissaoNotaFiscal();
  }

  confirmarEmissaoComValorAlto() {
    this.displayModalConfirmacaoValorAlto = false;
    this.executarEmissaoNotaFiscal();
  }

  cancelarEmissaoComValorAlto() {
    this.displayModalConfirmacaoValorAlto = false;
  }

  private obterValorServicosNumerico(): number {
    const raw = this.form.get('valorServicos')?.value;
    if (raw === null || raw === undefined || raw === '') {
      return 0;
    }
    if (typeof raw === 'number' && !Number.isNaN(raw)) {
      return raw;
    }
    let s = String(raw).trim().replace(/\s/g, '').replace(/R\$/gi, '');
    if (s.includes(',')) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (/^\d{1,3}(\.\d{3})+(\.\d+)?$/.test(s)) {
      s = s.replace(/\./g, '');
    }
    const parsed = parseFloat(s);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private executarEmissaoNotaFiscal() {
    this.spinnerService.show('Emitindo nota...');
    this.form.get('ambiente')?.setValue("producao");
    this.form.get('itemListaServico')?.enable();
    let campoOriginal = this.form.get('itemListaServico')?.value || '';

    let itemListaServicoValue = this.resolverItemListaServicoParaEmissao(campoOriginal);

    if (!itemListaServicoValue) {
      console.error("Erro: 'itemListaServico' está vazio!");
      this.spinnerService.hide();
      this.toastService.setMensagemToast(
        'Erro ao emitir nota fiscal: campo ItemListaServico não pode estar vazio.',
        SeveridadeToast.Error
      );
      return;
    }

    this.form.patchValue({
      baseCalculo: 0.0,
      aliquota: 0.0,
      valorIss: 0.0,
      descontoCondicionado: 0,
      descontoIncondicionado: 0,
      dataEmissao: new Date().toISOString(),
      usuarioId: this.userId,
      itemListaServico: itemListaServicoValue,
    });

    const formData = { ...this.form.value };
    formData.descontoCondicionado = 0;
    formData.descontoIncondicionado = 0;
    if (formData.dataEmissao) {
      formData.dataEmissao = this.ajustarDataParaBrasilia(formData.dataEmissao);
    }
    if (formData.isRetroativa && formData.dataCompetencia) {
      const dataCompetencia = formData.dataCompetencia instanceof Date
        ? formData.dataCompetencia
        : new Date(formData.dataCompetencia);
      formData.dataCompetencia = this.formatarDataCompetencia(dataCompetencia);
    } else {
      formData.dataCompetencia = this.formatarDataCompetencia(new Date());
    }

    this.notaFiscalServicoService.criarNfse(formData).subscribe({
      next: () => {
        this.showToastAndNavigate('NFS-e criada com sucesso!', SeveridadeToast.Success);
        this.spinnerService.hide();
      },
      error: () => {
        this.showToastAndNavigate('Erro ao criar a NFS-e!', SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });

    this.form.patchValue({ itemListaServico: campoOriginal });
  }

  preVisualizarNotaFiscal() {
    if (this.isEmitenteRondonopolisMt()) {
      this.toastService.setMensagemToast(
        'Rondonópolis/MT não possui ambiente de homologação. A pré-visualização não está disponível para este município.',
        SeveridadeToast.Warn
      );
      return;
    }

    this.spinnerService.show('Carregando nota para pré-visualização...');
    this.form.get('ambiente')?.setValue("homologacao");
    this.form.get('itemListaServico')?.enable();

    let campoOriginal = this.form.get('itemListaServico')?.value || '';

    let itemListaServicoValue = this.resolverItemListaServicoParaEmissao(campoOriginal);

    if (!itemListaServicoValue) {
      console.error("Erro: 'itemListaServico' está vazio!");
      this.spinnerService.hide();
      this.toastService.setMensagemToast(
        'Erro ao pré-visualizar nota fiscal: campo ItemListaServico não pode estar vazio.',
        SeveridadeToast.Error
      );
      return;
    }

    this.form.patchValue({
      baseCalculo: 0.0,
      aliquota: 0.0,
      valorIss: 0.0,
      descontoCondicionado: 0,
      descontoIncondicionado: 0,
      dataEmissao: new Date().toISOString(),
      usuarioId: this.userId,
      itemListaServico: itemListaServicoValue,
    });

    const formData = { ...this.form.value };
    formData.descontoCondicionado = 0;
    formData.descontoIncondicionado = 0;
    if (formData.dataEmissao) {
      formData.dataEmissao = this.ajustarDataParaBrasilia(formData.dataEmissao);
    }
    if (formData.isRetroativa && formData.dataCompetencia) {
      const dataCompetencia = formData.dataCompetencia instanceof Date
        ? formData.dataCompetencia
        : new Date(formData.dataCompetencia);
      formData.dataCompetencia = this.formatarDataCompetencia(dataCompetencia);
    } else {
      formData.dataCompetencia = this.formatarDataCompetencia(new Date());
    }

    this.notaFiscalServicoService.preVisualizarNfse(formData).subscribe({
      next: () => {
        this.loadNfses();
        this.spinnerService.hide();
      },
      error: () => {
        this.toastService.setMensagemToast('Erro ao pré-visualizar nota fiscal.', SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });

    this.form.patchValue({ itemListaServico: campoOriginal });
  }


  async loadNfses(): Promise<void> {
    const usuarioId = this.jwtHelper.getUserIdFromToken();

    this.notaFiscalServicoService
      .listaNotasFiscaisServico(usuarioId)
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe({
        next: async (data) => {
          this.notaFiscalServicoArray = data;
          await this.atualizarStatusNotas();
        },
        error: (error) => {
          this.toastService.setMensagemToast(
            `Erro ao carregar a lista de Nfs-e.`,
            SeveridadeToast.Error
          );
          this.spinnerService.hide();
        }
      });

    this.notaMaisRecente = this.carregaNotaMaisRecente(this.notaFiscalServicoArray)
  }

  carregaNotaMaisRecente(atualizarStatusNotas: NotaFiscalServicoModel[]): NotaFiscalServicoModel {

    this.mostrarNota = true;

    return atualizarStatusNotas
      .filter(obj => obj.usuarioId === this.userId)
      .reduce((maisRecente, atual) =>
        new Date(atual.dataEmissao) > new Date(maisRecente.dataEmissao) ? atual : maisRecente
      );
  }

  async atualizarStatusNotas(): Promise<void> {
    const notasParaAtualizar = this.notaFiscalServicoArray.filter(
      (nota) => nota.createNfseResponse.status === 'processando_autorizacao'
    );

    if (notasParaAtualizar.length === 0) return;

    this.spinnerService.show('Atualizando status das notas fiscais...');

    const atualizacoes = notasParaAtualizar.map(async (nota) => {
      try {
        const data = await lastValueFrom(
          this.notaFiscalServicoService.consultarNfse(nota.createNfseResponse.ref, nota.createNfseResponse.cnpj_prestador)
        );

        const notaIndex = this.notaFiscalServicoArray.findIndex(
          (n) => n.createNfseResponse.ref === nota.createNfseResponse.ref
        );

        if (notaIndex > -1) {
          const atual = this.notaFiscalServicoArray[notaIndex];
          this.notaFiscalServicoArray[notaIndex] = {
            ...atual,
            createNfseResponse: {
              ...atual.createNfseResponse,
              status: data.status,
              url: data.url ?? atual.createNfseResponse.url,
              caminho_xml_nota_fiscal:
                data.caminho_xml_nota_fiscal ?? atual.createNfseResponse.caminho_xml_nota_fiscal,
              numero: data.numero ?? atual.createNfseResponse.numero,
              codigo_verificacao: data.codigo_verificacao ?? atual.createNfseResponse.codigo_verificacao,
              data_emissao: data.data_emissao ?? atual.createNfseResponse.data_emissao,
              numero_rps: data.numero_rps ?? atual.createNfseResponse.numero_rps,
              serie_rps: data.serie_rps ?? atual.createNfseResponse.serie_rps,
              erros: data.erros ?? atual.createNfseResponse.erros
            }
          };
        }
      } catch (error) {
        this.toastService.setMensagemToast(
          `Erro ao consultar status da NFS-e com referência ${nota.createNfseResponse.ref}.`,
          SeveridadeToast.Error
        );
      }
    });

    await Promise.all(atualizacoes);

    this.notaFiscalServicoArray = [...this.notaFiscalServicoArray];

    this.spinnerService.hide();

    await this.loadNfses();
  }

  private showToastAndNavigate(message: string, severity: SeveridadeToast) {
    this.toastService.setMensagemToast(message, severity);
    setTimeout(() => this.router.navigate(['/listagem-nfs-e']), 3000);
  }

  redirecionaParaCadastro() {
    this.router.navigate(['/clientes/adicionar']);
  }

  redirecionaParaDescricaoPadrao() {
    this.router.navigate(['/descricao-padrao/adicionar']);
  }

  voltar() {
    this.location.back();
  }
  private checkForReplicatedData() {
    const state = window.history.state;
    if (state && state.replicatedData) {
      this.populateFormWithReplicatedData(state.replicatedData);
      this.aplicarValidacaoCodigoNbsPorMunicipio();
    }
  }

  isEmitenteSaoGoncaloRj(): boolean {
    return this.codigoMunicipioIbgePrestador === NfseEmissaoComponent.CodigoMunicipioSaoGoncaloRj;
  }

  isEmitenteTeresinaPi(): boolean {
    return this.codigoMunicipioIbgePrestador === NfseEmissaoComponent.CodigoMunicipioTeresinaPi;
  }

  isEmitenteRondonopolisMt(): boolean {
    return this.codigoMunicipioIbgePrestador === NfseEmissaoComponent.CodigoMunicipioRondonopolisMt;
  }

  isEmitenteMesquitaRj(): boolean {
    return this.codigoMunicipioIbgePrestador === NfseEmissaoComponent.CodigoMunicipioMesquitaRj;
  }

  municipioNaoExigeCodigoNbs(): boolean {
    return this.isEmitenteSaoGoncaloRj() || this.isEmitenteTeresinaPi();
  }

  private resolverItemListaServicoParaEmissao(campoOriginal: string): string {
    const token = campoOriginal.trim().length > 0
      ? campoOriginal.split(' ')[0].trim()
      : campoOriginal;

    if (this.isEmitenteRondonopolisMt() || this.isEmitenteTeresinaPi()) {
      return token;
    }

    if (this.isEmitenteMesquitaRj()) {
      const digits = token.replace(/\D/g, '');
      if (digits.length >= 6) {
        return digits.slice(0, 6);
      }
      if (digits.length === 4) {
        return `${digits}01`;
      }
      return digits.length > 0 ? digits.padEnd(6, '0').slice(0, 6) : '171401';
    }

    return token.replace('.', '');
  }

  private normalizarCodigoIbgeMunicipio(
    raw: string | number | null | undefined
  ): string | null {
    if (raw === null || raw === undefined) {
      return null;
    }
    const digits = String(raw).replace(/\D/g, '');
    if (!digits) {
      return null;
    }
    return digits.length >= 7 ? digits.slice(-7) : digits.padStart(7, '0');
  }

  private aplicarValidacaoCodigoNbsPorMunicipio(): void {
    const ctrl = this.form.get('codigoNbs');
    if (!ctrl) {
      return;
    }
    if (this.isEmitenteSaoGoncaloRj()) {
      ctrl.clearValidators();
      ctrl.setValue('1.1301.20.00', { emitEvent: false });
    } else if (this.isEmitenteTeresinaPi()) {
      ctrl.clearValidators();
      ctrl.setValue('', { emitEvent: false });
    } else {
      ctrl.setValidators([Validators.required]);
    }
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  private populateFormWithReplicatedData(replicatedData: any) {
    if (replicatedData.clienteId) {
      this.form.patchValue({ clienteId: replicatedData.clienteId });
      this.onTomadorChange({ value: replicatedData.clienteId });
    } else if (replicatedData.tomador) {
      const doc = replicatedData.tomador.cnpj || replicatedData.tomador.cpf;
      if (doc) this.selectClienteOption(doc);
    }

    if (replicatedData.servico) {
      this.populateFieldsValores(replicatedData.servico);

      if (replicatedData.servico.discriminacao) {
        this.selectDescricaoOption(replicatedData.servico.discriminacao);
      }
    }
  }

  private populateFieldsValores(servico: any) {
    if (servico) {
      this.form.patchValue({
        valorServicos: servico.valor_servicos || 0,
        descontoCondicionado: 0,
        descontoIncondicionado: 0,
        baseCalculo: servico.base_calculo || 0,
        aliquota: servico.aliquota || 0,
        valorIss: servico.valor_iss || 0,
      });
    }
  }

  private selectClienteOption(documento: string) {
    const normalize = (v: string) => FormatadorHelper.normalizarDocumento(v);
    const alvo = normalize(documento);
    const clienteOption = this.clienteOptions.find((option) => {
      const labelDoc = normalize(String(option.label).split(' - ')[0] || '');
      return labelDoc === alvo;
    });
    if (clienteOption) {
      this.form.patchValue({ clienteId: clienteOption.value });
      this.onTomadorChange({ value: clienteOption.value });
    }
  }

  private selectDescricaoOption(discriminacao: string) {
    const descricaoOption = this.descricaoPadraoOptions.find(
      (option) => option.detalhes === discriminacao
    );
    if (descricaoOption) {
      this.form.patchValue({ descricaoId: descricaoOption.value });
      this.form.patchValue({ discriminacao: descricaoOption.detalhes });
    }
  }

  ajustarDataParaBrasilia(data: string | Date): string {
    let dataObj: Date;

    if (typeof data === 'string') {
      dataObj = new Date(data);
    } else {
      dataObj = data;
    }

    const dataBrasilia = new Date(dataObj.getTime() - (3 * 60 * 60 * 1000));
    return dataBrasilia.toISOString();
  }

  formatarDataCompetencia(data: Date): string {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  formataData(data: Date) {
    var dataFormatada = new Date(data).toLocaleDateString('pt-BR');
    return dataFormatada
  }

  downloadNota(url: string) {
    const fullUrl = url.startsWith('http') ? url : `https://${url}`;
    window.open(fullUrl, '_blank');
  }


}
